const SimpleSpinner = ({ className = 'h-12 w-12 text-blue-300' }) => (
  <svg
    className={`${className} animate-spin-custom`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      d="M12 2 a 10 10 0 0 1 0 20 a 10 10 0 0 1 0 -20"
      strokeDasharray="47.1 15.7"
    />
    <style>{`
      @keyframes spin-custom {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .animate-spin-custom {
        animation: spin-custom 1.2s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
      }
    `}</style>
  </svg>
);

export default SimpleSpinner;
